/**
 * Freie Eingabe einer Buchungsdauer → Stunden (minutengenau). `null` = nicht lesbar.
 *
 * Verstanden wird, was Techniker tippen:
 * - `1:15` → Stunden:Minuten
 * - `1h 15`, `1 h 15 min`, `2h`, `45 min`, `45m` → mit Einheit
 * - `1,5` / `1.5` → Stunden (Dezimalzahl)
 * - ganze Zahl ohne Einheit: bis 8 Stunden, darüber Minuten (`2` = 2 h, `38` = 38 min)
 *   — eine Buchung über mehr als 8 Stunden am Stück ist selten, 1–8 Minuten ebenso.
 */
export function parseDurationInput(raw: string): number | null {
  const s = raw.trim().toLowerCase().replace(/\s+/g, ' ');
  if (!s) return null;

  const hm = /^(\d{1,2}):(\d{1,2})$/.exec(s);
  if (hm) return toHours(Number(hm[1]) * 60 + Number(hm[2]));

  const withUnits = /^(?:(\d+(?:[.,]\d+)?) ?(?:h|std\.?|stunden?))? ?(?:(\d+) ?(?:m|min\.?|minuten?)?)?$/.exec(s);
  if (withUnits && /[a-z]/.test(s) && (withUnits[1] || withUnits[2])) {
    const h = withUnits[1] ? Number(withUnits[1].replace(',', '.')) : 0;
    const m = withUnits[2] ? Number(withUnits[2]) : 0;
    return toHours(Math.round(h * 60) + m);
  }

  if (/^\d+[.,]\d+$/.test(s)) return toHours(Math.round(Number(s.replace(',', '.')) * 60));

  if (/^\d+$/.test(s)) {
    const n = Number(s);
    return toHours(n <= 8 ? n * 60 : n);
  }
  return null;
}

function toHours(minutes: number): number | null {
  if (!Number.isFinite(minutes) || minutes <= 0) return null;
  return minutes / 60;
}
